import React from 'react';
import { Button, Result } from 'antd';
import { FormattedMessage } from 'react-intl';
import { PageDashboard } from '../../consts/routes';

const UnauthorizedResult = ({ router }) => {
  const { pathname } = router;
  const isHome = pathname === PageDashboard;

  return (
    <Result
      status="403"
      title="403"
      subTitle={<FormattedMessage id="page403.subtitle" />}
      extra={
        !isHome && (
          <Button type="primary" onClick={() => router.replace(PageDashboard)}>
            <FormattedMessage id="action.backHome" />
          </Button>
        )
      }
    />
  );
};

export default UnauthorizedResult;
